import React from "react"
import InputAdornment from "@mui/material/InputAdornment"
import ClearIcon from "@mui/icons-material/Clear"
import { IconButton } from "@mui/material"

const clearButton = ({ searchString, handleSearchStringClear, tabIndex, textInput }) => {

  const handleOnClick = (tabIndex, textInput) => {
    if (textInput)
      textInput.current.value = ""
    handleSearchStringClear(tabIndex)
  }

  return {
    endAdornment: (searchString &&
      <InputAdornment position="end">
        <IconButton
          edge="end"
          onClick={() => handleOnClick(tabIndex, textInput)}
          size="small"
        >
          <ClearIcon />
        </IconButton>
      </InputAdornment>)
  }
}

export default clearButton